import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

import { useFilter } from './useFilter';

export default function useSearchConversation() {
    const { t } = useTranslation('inbox');
    const [{ assign, searchValue }, setFilter] = useFilter();

    const placeholder = useMemo(() => {
        switch (assign) {
            case 'unassigned':
                return t('conversationBar.searchPlaceholder.unassigned');
            case 'my':
                return t('conversationBar.searchPlaceholder.my');
            case 'all':
                return t('conversationBar.searchPlaceholder.all');
            default:
                return t('searchConversation.search');
        }
    }, [assign]);

    const onChange = (v) => setFilter({ searchValue: v });

    return { placeholder, value: searchValue, onChange };
}
